export default __webpack_public_path__ + "static/media/icon-other-active.3efa0ed3.svg";